export const ERROR_CODES = {
    ERR_WS_INIT : {
        message: 'Socket connection failed',
        action: 'show',
        code: 'ERR_WS_INIT',
        details: {
          requiredFields: ['token', 'conversationId'],
        }
        // timestamp: new Date().toISOString()
    },
    ERR_WS_TIMEOUT : {
        message: 'Socket connection timeout',
        action: 'show',
        code: 'ERR_WS_INIT',
        details: {
            requiredFields: ['token','conversationId'],
        }
    },      
    ERR_WS_DISCONNECT : {
        message: 'Socket disconnected',
        action: 'show',
        code: 'ERR_WS_INIT',
        details: {
            requiredFields: ['token','conversationId'],
        }
    },
    ERR_WS_RECONNECT_FAILED : {
        message: 'Socket reconnection failed',
        action: 'show',
        code: 'ERR_WS_INIT',
        details: {
            requiredFields: ['token','conversationId'],
        }
    },
    ERR_WS_GENERIC : {
        message: 'Socket error',
        action: 'show',
        code: 'ERR_WS_INIT',
        details: {
            requiredFields: ['token','conversationId'],
        }
    },
    ERR_SETTINGS_API_FAILURE : {
        message: 'Settings API failed',
        action: 'show',
        code: 'ERR_SETTINGS_API_FAILURE',
        details: {
            requiredFields: ['botId',  'channel'],
        }
    },
    ERR_PREFS_API_FAILURE : {
        message: 'Prefs API failed',
        action: 'show',
        code: 'ERR_PREFS_API_FAILURE',
        details: {
            requiredFields: ['botId',  'channel', 'instanceBotId', 'lang'],
        }
    },
    ERR_TOKEN_INVALID : {
        message: 'Invalid token',
        action: 'show',
        code: 'ERR_TOKEN_INVALID',
        details: {
            requiredFields: ['token', 'botId'],
        }
    },
    ERR_CHECKLIST_API_FAILURE : {
        message: 'Checklist API failed',
        action: 'show',
        code: 'ERR_CHECKLIST_API_FAILURE',
        details: {
            requiredFields: ['botId'],
        }
    },
    ERR_ASST_HISTORY_API_FAILURE : {
        message: 'Assist history API failed',
        action: 'show',
        code: 'ERR_ASST_HISTORY_API_FAILURE',
        details: {
            requiredFields: ['botId', 'conversationId'],
        }
    },
    ERR_MYBOT_HISTORY_API_FAILURE : {
        message: 'Mybot history API failed',
        action: 'show',
        code: 'ERR_MYBOT_HISTORY_API_FAILURE',
        details: {
            requiredFields: ['botId', 'conversationId'],
        }
    },
    ERR_FEEDBACK_API_FAILURE : {
        message: 'Feedback API failed',
        action: 'show',
        code: 'ERR_FEEDBACK_API_FAILURE',
        details: {
            requiredFields: ['tab', 'conversationId'],
        }
    },
    ERR_SUMMARY_LOAD_FAILURE : {
        message: 'Summary load failed',
        action: 'show',
        code: 'ERR_SUMMARY_LOAD_FAILURE',
        details: {
            requiredFields: ['conversationId', 'botId', 'channel', 'sessionId'],
        }
    },
    ERR_AUTO_SUGGESTION_TRIGGER_FAILURE : {
        message: 'Auto suggestion trigger failed',
        action: 'show',
        code: 'ERR_AUTO_SUGGESTION_TRIGGER_FAILURE',
        details: {
            requiredFields: [],
        }
    },
    ERR_USER_MISSING_REQ_FIELDS : {
        message: 'Missing required fields to send user message',
        action: 'sendUserMessage',
        code: 'ERR_MISSING_REQ_FIELDS',
        details: {
            requiredFields: ['author', 'type', 'conversationId', 'value', 'botId'],
        }
    },
    ERR_AGENT_MISSING_REQ_FIELDS : {
        message: 'Missing required fields to send agent message',
        action: 'sendAgentMessage',
        code: 'ERR_MISSING_REQ_FIELDS',
        details: {
            requiredFields: ['author', 'type', 'conversationId', 'value', 'botId'],
        }
    },
    ERR_JS_CODE : {
        message: 'JS code failed',
        action: 'show',
        code: 'ERR_JS_CODE_FAILURE',
        details: {
            requiredFields: [],
        }
    },
    ERR_MISSING_REQUIRED_FIELDS : {
        message: 'Missing required fields to initialize the SDK',
        action: 'show',
        code: 'ERR_MISSING_REQUIRED_FIELDS',
        details: {
            requiredFields: ['conversationId', 'botId', 'domainURL', 'token', 'channel'],
        }
    },
    ERR_AGENTIC_COPILOT_HISTORY_API_FAILURE : {
        message: 'Agentic copilot history API failed',
        action: 'show',
        code: 'ERR_AGENTIC_COPILOT_HISTORY_API_FAILURE',
        details: {
            requiredFields: ['']
        }
    }


    // ERR_VOICE_TRANSCRIPTS_PROPOGATION : {
    //     message: 'Voice transcripts propogation failed',
    //     action: 'show',
    //     code: 'ERR_VOICE_TRANSCRIPTS_PROPOGATION',
    //     details: {
    //         requiredFields: [],
    //     }
    // },
    // ERR_VOICE_CALL_DOES_NOT_EXIST : {
    //     message: 'Voice call does not exist',
    //     action: 'show',
    //     code: 'ERR_VOICE_CALL_DOES_NOT_EXIST',
    //     details: {
    //         requiredFields: [],
    //     }
    // },
    // ERR_VOICE_TRANSCRIPTS_GENERATION : {
    //     message: 'Voice transcripts generation failed',
    //     action: 'show',
    //     code: 'ERR_VOICE_TRANSCRIPTS_GENERATION',
    //     details: {
    //         requiredFields: [],
    //     }
    // },
    // ERR_VOICE_PREMATURE_CONNECTION_TERMINATION : {
    //     message: 'Voice connection terminated prematurely',
    //     action: 'show',
    //     code: 'ERR_VOICE_PREMATURE_CONNECTION_TERMINATION',
    //     details: {
    //         requiredFields: [],
    //     }
    // }
}
